import React from "react";
import { Route } from "react-router-dom";
//
import { URL } from "../url";
// component
import LayoutRoot from "../layout/layout_root";
import PrivateRoute from "../component/private_route";
//client
import SupporterScreen from "screen/02_Supporter/supporter";
//
import DevScreen from "screen/100_Dev/dev";
import HistoryScreen from "screen/03_History/history";

//concept

const PERMISSION_SCREEN = "as";

export const routerPrivate = () => {
  // -------------------------- STATE --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Route exact path={URL.home} element={<LayoutRoot />}>
      <Route
        index
        element={
          <PrivateRoute
            require={[PERMISSION_SCREEN]}
            element={<SupporterScreen />}
          />
        }
      />

      <Route
        path={URL.wallet}
        element={
          <PrivateRoute
            require={[PERMISSION_SCREEN]}
            element={<HistoryScreen />}
          />
        }
      />

      <Route
        path={URL.dev}
        element={<PrivateRoute require={[]} element={<DevScreen />} />}
      />
    </Route>
  );
};
